import { Box, Paper, Grid, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";
import AppTextInput from "../../app/components/AppTextInput";
import DonationFormModel from "./common/donationFormModel";
import { MapFundsToAutocompleteItems } from "../../app/utils/convertStaticDataToDropdownItems";
import AppCheckboxField from "../../app/components/AppCheckboxField";
import { useAppSelector } from "../../app/store/configureStore";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { getCurrencyByRegion } from "../../app/utils/util";
import { AutocompleteItem } from "../../app/models/common/autocompleteItem";
import AppAutocomplete from "../../app/components/AppAutocomplete";
import { useAppInsightsContext } from "@microsoft/applicationinsights-react-js";

export default function DonationDetails() {
    const appInsights = useAppInsightsContext();
    const methods = useFormContext();
    const { control } = methods;

    const { funds, currencies } = useAppSelector(state => state.ReferenceData);
    const [fundsByCurrency, setFundsByCurrency] = useState<AutocompleteItem[]>([]);

    const { region } = useParams<{ region: string }>();

    useEffect(() => {
        let currencyId = currencies?.find(x => x.code === getCurrencyByRegion(region).toString())?.id;
        setFundsByCurrency(MapFundsToAutocompleteItems(funds?.filter(x => x.currencyId === currencyId && x.active === true) ?? []));
        appInsights.trackEvent({ name: "Donation - Donation details - on load" });
    }, []);

    const {
        formField: {
            Fund,
            GiftAmount,
            WillingToLeaveLegacy
        }
    } = DonationFormModel;

    return <>
        <Box sx={{ width: '100%' }} component={Paper}>

            <Grid container rowSpacing={4} sx={{ margin: "2%" }}>

                <Grid size={{ xs: 12 }}></Grid>
                
                <Grid size={{ xs: 12 }}>
                    <Typography variant='subtitle1' sx={{ fontWeight: "500" }}>Donation details</Typography>
                </Grid>

                <Grid size={{ xs: 12 }}>
                    <AppAutocomplete control={control} name={Fund.name} label={Fund.label} items={fundsByCurrency} />
                </Grid>

                <Grid size={{ xs: 12 }}>
                    <AppTextInput control={control} name={GiftAmount.name} label={GiftAmount.label.replace("##CURRENCY_PLACE_HOLDER##", getCurrencyByRegion(region))} />
                </Grid>

                <Grid size={{ xs: 12 }}>
                    <AppCheckboxField
                        control={control}
                        name={WillingToLeaveLegacy.name}
                        label={WillingToLeaveLegacy.label}
                        options={[{
                            id: WillingToLeaveLegacy.name,
                            value: WillingToLeaveLegacy.label
                        }]} />
                </Grid>

                <Grid size={{ xs: 12 }}></Grid>

            </Grid>
        </Box>
    </>
}